"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BriefcaseIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BriefcaseIcon, _PureComponent);

  function BriefcaseIcon() {
    _classCallCheck(this, BriefcaseIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(BriefcaseIcon).apply(this, arguments));
  }

  _createClass(BriefcaseIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 35",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M25,55.75A1.25,1.25,0,0,1,23.75,57h-7.5A1.25,1.25,0,0,1,15,55.75V52H0V63.25A3.845,3.845,0,0,0,3.75,67h32.5A3.845,3.845,0,0,0,40,63.25V52H25ZM36.25,39.5H30V35.75A3.845,3.845,0,0,0,26.25,32H13.75A3.845,3.845,0,0,0,10,35.75V39.5H3.75A3.845,3.845,0,0,0,0,43.25V49.5H40V43.25A3.845,3.845,0,0,0,36.25,39.5ZM25,39.5H15V37H25Z",
        transform: "translate(0 -32)"
      }));
    }
  }]);

  return BriefcaseIcon;
}(_react.PureComponent);

exports.default = BriefcaseIcon;